/**
 * FE mirror of backend Mentis.Domain/Authorization/PermissionCatalog.cs.
 * Keep PERMISSION_CODES in sync with PermissionCatalog.All (convention test guards it).
 * Route map mirrors each route's controller GET [RequirePermission] code.
 * Read-only routes (/, /search, /notifications) are intentionally absent = ungated.
 */
export const PERMISSION_CODES = [
  'users.view', 'users.create', 'users.edit', 'users.delete',
  'roles.view', 'roles.create', 'roles.edit', 'roles.delete',
  'tickets.view', 'tickets.create', 'tickets.edit', 'tickets.delete', 'tickets.assign',
  'customers.view', 'customers.create', 'customers.edit', 'customers.delete',
  'projects.view', 'projects.create', 'projects.edit', 'projects.delete',
  'inventory.view', 'inventory.create', 'inventory.edit', 'inventory.delete',
  'services.view', 'services.create', 'services.edit', 'services.delete',
  'quotes.view', 'quotes.create', 'quotes.edit', 'quotes.delete',
  'kb.view', 'kb.create', 'kb.edit', 'kb.delete',
  'reports.view', 'reports.export',
  'settings.view', 'settings.edit',
  'announcements.view', 'announcements.edit',
] as const;

export const ROUTE_VIEW_PERMISSION: Record<string, string> = {
  '/tickets': 'tickets.view',
  '/customers': 'customers.view',
  '/contracts': 'customers.view',
  '/quotes': 'quotes.view',
  '/appointments': 'services.view',
  '/licenses': 'inventory.view',
  '/projects': 'projects.view',
  '/inventory': 'inventory.view',
  '/services': 'services.view',
  '/knowledge-base': 'kb.view',
  '/announcements': 'announcements.view',
  '/teams': 'users.view',
  '/users': 'users.view',
  '/problems': 'tickets.view',
  '/change-requests': 'tickets.view',
  '/approvals': 'tickets.view',
  '/reports': 'reports.view',
  '/roles': 'roles.view',
  '/sla': 'settings.view',
  '/audit-logs': 'settings.view',
  '/templates': 'settings.view',
  '/custom-fields': 'settings.view',
  '/assignment-rules': 'settings.view',
  '/escalation-rules': 'settings.view',
  '/automation-rules': 'settings.view',
  '/recurring-tickets': 'settings.view',
  '/business-calendars': 'settings.view',
  '/branding': 'settings.view',
  '/settings': 'settings.view',
};
